import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "text-filter",
  template: `
        <div class="adc-d-flex adc-gap-3 adc-align-items-center adc-ml8 adc-mr8 adc-mb10" (click)="$event.stopPropagation()">
        	<select class="adc-select adc-cursor-pointer adc-iptgrp-errtxt" [(ngModel)]="selectedFilter1" (change)="searchFilter($event)">
        		<option *ngFor="let i of filterArr" [value]="i.id" class="adc-cursor-pointer">{{ i.label | translate}}</option>
        	</select> 
        </div>
        <div class="adc-d-flex adc-align-items-center adc-position-relative adc-ml8 adc-mt5 adc-mr8 adc-srh" (click)="$event.stopPropagation()">
        	<input type="text" name="" [(ngModel)]="searchVal1" class="adc-pr40" placeholder="{{'Search' | translate}}.." value="" (keyup)="searchFilter($event)" />
        	<svg
        		xmlns="http://www.w3.org/2000/svg" class="adc-cursor-pointer" class="adc-position-absolute adc-r15" height="24px" viewBox="0 -960 960 960" width="20px" fill="#000">
        		<path d="M783.52-110.91 529.85-364.59q-29.76 23.05-68.64 36.57-38.88 13.52-83.12 13.52-111.16 0-188.33-77.17-77.17-77.18-77.17-188.33t77.17-188.33q77.17-77.17 188.33-77.17 111.15 0 188.32 77.17 77.18 77.18 77.18 188.33 0 44.48-13.52 83.12-13.53 38.64-36.57 68.16l253.91 254.15-63.89 63.66ZM378.09-405.5q72.84 0 123.67-50.83 50.83-50.82 50.83-123.67t-50.83-123.67q-50.83-50.83-123.67-50.83-72.85 0-123.68 50.83-50.82 50.82-50.82 123.67t50.82 123.67q50.83 50.83 123.68 50.83Z" />
        	</svg>
        </div>
        <div *ngIf="secondaryFilter">
        	<div class="adc-mt10 adc-mb10" (click)="$event.stopPropagation()">
        		<form class="adc-rdogrp-hr adc-p0 adc-pl8 adc-pr8">
        			<div class="adc-rdo" *ngFor="let data of data_hr">
        				<input type="radio" value="" [id]="data.id" [name]="data.name" [checked]="data.checked" [disabled]="data.disabled" />
        				<label for="data.id">{{ data.label }}</label>
        			</div>
        		</form>
        	</div>
        	<div class="adc-d-flex adc-gap-3 adc-align-items-center adc-ml8 adc-mr8 adc-mb10 adc-w-75" (click)="$event.stopPropagation()">
        		<select class="adc-select adc-cursor-pointer adc-iptgrp-errtxt" [(ngModel)]="selectedFilter2" (change)="searchFilter($event)">
        			<option *ngFor="let i of filterArr" [value]="i.id" class="adc-cursor-pointer">{{ i.label | translate}}</option>
        		</select>
        	</div>
        	<div class="adc-d-flex adc-align-items-center adc-position-relative adc-ml8 adc-mt5 adc-mr8 adc-srh" (click)="$event.stopPropagation()">
        		<input type="text" name="" [(ngModel)]="searchVal2" class="adc-pr40" placeholder="Search.." value="" (keyup)="searchFilter($event)" />
        		<svg
        			xmlns="http://www.w3.org/2000/svg" class="adc-cursor-pointer" class="adc-position-absolute adc-r15" height="24px" viewBox="0 -960 960 960" width="20px" fill="#000">
        			<path d="M783.52-110.91 529.85-364.59q-29.76 23.05-68.64 36.57-38.88 13.52-83.12 13.52-111.16 0-188.33-77.17-77.17-77.18-77.17-188.33t77.17-188.33q77.17-77.17 188.33-77.17 111.15 0 188.32 77.17 77.18 77.18 77.18 188.33 0 44.48-13.52 83.12-13.53 38.64-36.57 68.16l253.91 254.15-63.89 63.66ZM378.09-405.5q72.84 0 123.67-50.83 50.83-50.82 50.83-123.67t-50.83-123.67q-50.83-50.83-123.67-50.83-72.85 0-123.68 50.83-50.82 50.82-50.82 123.67t50.82 123.67q50.83 50.83 123.68 50.83Z" />
        		</svg>
        	</div>
        </div>`, 
        standalone: false
})
export class TextFilterComponent {
    @Input() columnName: string = '';
    @Output() searchFilterVal = new EventEmitter();
    searchVal1: any;
    searchVal2: any;
    selectedFilter1: number = 1;
    selectedFilter2: number = 1;
    secondaryFilter: boolean = false;
    filterArr: any = [
        {
            id: 1,
            label: "Contains",
        },
        {
            id: 2,
            label: "Does not contain",
        },
        {
            id: 3,
            label: "Equals",
        },
        {
            id: 4,
            label: "Does not equals",
        },
        {
            id: 5,
            label: "Begins with",
        },
        {
            id: 6,
            label: "Ends with",
        },
    ];
    data_hr = [
        {
            label: "AND",
            id: "1",
            checked: true,
            disabled: false,
            name: "filter",
        },
        {
            label: "OR",
            id: "2",
            checked: false,
            disabled: false,
            name: "filter",
        },
    ];

    clearFilter() {
        this.searchVal1 = '';
        this.selectedFilter1 = 1;
    }

    searchFilter(e: Event) {
        this.searchFilterVal.emit({
            searchVal: this.searchVal1,
            selectedFilter: this.selectedFilter1
          });
    }

    onChange(event: any) {
        console.log(event.target.value)
    }
}
